import { render, staticRenderFns } from "./CompetitiveBrandsCaseStudyScreen.vue?vue&type=template&id=cf54e32a"
import script from "./CompetitiveBrandsCaseStudyScreen.vue?vue&type=script&lang=js"
export * from "./CompetitiveBrandsCaseStudyScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports